import { PieChart, Pie, Cell, Tooltip, Label } from "recharts";
import { Task } from "../../../types/tasks";
import { Empty } from "antd";

const TaskPieChart = ({
  tasks,
  name,
  size,
}: {
  tasks: Task[] | undefined;
  name: string;
  size: "big" | "small";
}) => {
  const successCount = tasks?.filter(
    (task) => task.taskStatus.status === "SUCCESSFUL"
  ).length;
  const errorCount = tasks?.filter(
    (task) => task.taskStatus.status === "ERROR"
  ).length;

  const pieData = [
    { name: "Successful", value: successCount, color: "#28a745" },
    { name: "Error", value: errorCount, color: "#dc3545" },
  ];

  const isBig = size === "big";
  const width = isBig ? 516 : 250;
  const height = isBig ? 516 : 250;
  const innerRadius = isBig ? 150 : 50;
  const outerRadius = isBig ? 180 : 80;
  const labelDy = isBig ? 0 : -90;
  const labelFont = isBig ? 24 : 12;

  const isEmpty =
    tasks?.length === 0 || (successCount === 0 && errorCount === 0);

  if (isEmpty) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        style={{ padding: "100px 103px" }}
      />
    );
  }

  return (
    <div>
      <PieChart width={width} height={height}>
        <Pie
          data={pieData}
          dataKey="value"
          nameKey="name"
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          label
        >
          {pieData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
          <Label
            value={name}
            dy={labelDy}
            position="center"
            fill="#333"
            fontSize={labelFont}
            fontWeight="bold"
          />
        </Pie>
        <Tooltip />
      </PieChart>
    </div>
  );
};

export default TaskPieChart;
